var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    staticClass: "d-flex flex-column align-center mb-8 rounded-lg"
  }, [_c('h1', {
    staticClass: "text-h2 text-center primary--text font-weight-bold"
  }, [_vm._v("BOARD OF TRUSTEES")]), _c('board-members-card', {
    staticClass: "my-16",
    attrs: {
      "id": "members"
    }
  }), _c('director-card', {
    staticClass: "my-16"
  }), _c('board-documents', {
    staticClass: "my-16",
    attrs: {
      "id": "documents"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }